import {getField, updateField} from 'vuex-map-fields';
import CommonArray from '@/commonFunction/arrayFunction'

export default {
    modules: {
        StoreDocItem: {
            namespaced: true,
            state: {
                storeDocItem: null,
                storeChildrenFileList: [],
                loading: false,
                saveLoading: false,
                searchTermFile: null,
            },

            actions: {
                async fetchItem(ctx, itemId) {
                    const requestParams = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                        },
                    };
                    let url = "/api/store_doc/" + itemId + "/"
                    let res = await fetch(url, requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateLoading', false)
                        return
                    }
                    const item = await res.json();
                    ctx.commit('updateItem', item)
                },
                async fetchSaveItem(ctx, item) {
                    ctx.commit('updateSaveLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    const requestParams = {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: JSON.stringify({
                            'title': item.title,
                            'description': item.description,
                        })
                    };
                    const res = await fetch("/api/store_doc/" + item.id + "/", requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateSaveLoading', false)
                    }
                    const result = await res.json()
                    ctx.commit('updateItem', result)
                    ctx.commit('updateSaveLoading', false)
                },
                async fetchChildList(ctx, itemId) {
                    ctx.commit('updateLoading', true)
                    const requestParams = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                        },
                    };
                    let url = "/api/store_file/?store_doc_id=" + itemId + '&order_by=store_doc_order'
                    let res = await fetch(url, requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateLoading', false)
                        return
                    }
                    const items = await res.json();
                    ctx.commit('updateChildrenItems', items.results)
                    ctx.commit('updateLoading', false)
                },
                async fetchChildUpdateOrder(ctx) {
                    console.log('fetchChildUpdateOrder')
                    ctx.commit('updateLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    for (const [index, childItem] of ctx.state.storeChildrenFileList.entries()) {
                        if (childItem.store_doc_order !== index) {
                            const requestParams = {
                                method: "PATCH",
                                headers: {
                                    "Content-Type": "application/json",
                                    'credentials': "same-origin",
                                    'X-CSRFToken': csrfToken,
                                },
                                body: JSON.stringify({
                                    'store_doc_order': index,
                                })
                            };
                            let url = "/api/store_file/" + childItem.id + '/'
                            let res = await fetch(url, requestParams);
                            if (!res.ok) {
                                const result = await res.json()
                                this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                                return
                            }
                        }
                    }
                    ctx.commit('updateLoading', false)
                },
                async fetchChildAddItem(ctx, item) {
                    ctx.commit('updateLoading', true)
                    console.log('item', item)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    let data = new FormData()
                    if (item.file)
                        data.append('file', item.file)
                    data.append('title', item.title)
                    if (item.description)
                        data.append('description', item.description)
                    data.append('store_doc', item.store_doc)
                    const requestParams = {
                        method: "POST",
                        headers: {
                            // "Content-Type": "multipart/form-data",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: data,
                    };
                    const res = await fetch("/api/store_file/", requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        console.log('result')
                        console.log(JSON.stringify(result))
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateLoading', false)
                    }
                    const result = await res.json()
                    console.log('result')
                    console.log(result)
                    let storeChildrenFileList = ctx.state.storeChildrenFileList
                    storeChildrenFileList.push(result)
                    ctx.commit('updateChildrenItems', storeChildrenFileList)
                    ctx.commit('updateLoading', false)
                },
            },

            mutations: {
                updateField,
                updateItem(state, item) {
                    state.storeDocItem = item
                },
                updateChildrenItems(state, items) {
                    state.storeChildrenFileList = items
                },
                updateLoading(state, loading) {
                    state.loading = loading
                },
                updateSaveLoading(state, saveLoading) {
                    state.saveLoading = saveLoading
                },
            },

            getters: {
                getField,
            }
        }
    }
}